export const flickityOptionsRecommendations = {
    initialIndex: 1, 
    contain: false,
    autoPlay: 6500,
    wrapAround: true,
    friction: 0.3,
    cellAlign: 'center',
    pageDots: false,
    groupCells: true,
}

export const moreTrailerFlickityOptions = {
    initialIndex: 0, 
    contain: false,
    wrapAround: false,
    friction: 0.2,
    pageDots: false,
    cellAlign: 'center',
}

export const flickityOptionsHome = {
    accessibility: true,
    initialIndex: 4, 
    autoPlay: 7500,
    wrapAround: true,
    friction: 0.3,
    cellAlign: 'center', 
    resize: true, 
    fullscreen: true
}
         